<template>
    <div v-if="dataSource && dataSourceType === 'OutgoingDocumentDSP'"
        :key="document.id"
        class="p-relative"
    >

        <Toolbar 
            :menu="dataSource.Data.Menu" 
            v-on:toolbar-button-click="onToolbarClick"  
        />

        <DocumentPanel :document-info="dataSource.Data.Object" />

        <v-tabs
            v-model="tab"
            background-color="transparent"
            slider-size="3"
            class="tab-selector-panel"
            mobile-breakpoint="0"
        >
            <v-tabs-slider color="#E43958"></v-tabs-slider>

            <v-tab 
                v-for="item in pages"
                :key="document.id + item.FormId"
                @click="onTabClicked(item.FormId)"
            >
                <template v-if="item.Count < 0">
                    {{ item.Name }}
                </template> 
                <template v-else>
                    {{ item.Name }}
                    <span class="count" id="attachCounter">{{ item.Count }}</span>
                </template>   
            </v-tab>
        
        </v-tabs>

        <v-tabs-items
            v-model="tab"
            class="tab-content-panel"
        >
            <v-tab-item 
                v-for="item in pages"
                :key="document.id + item.FormId"
            >
                <template v-if="item.FormId == document.id">
                    <v-form class="wrapperForm" ref="form" lazy-validation>
                        <v-row dense>
                            
                            <!--Обертка для секции-->
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">
                                
                                <!--Блок Сведения о регистрации-->
                                <v-card flat>
                                    <v-card-text>

                                        <div class="form-box-title">{{ $t("Сведения_о_регистрации") }}</div>

                                        <!--Поле Номенклатура-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Номенклатура") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Nomenclature ? `${document.Nomenclature.Code} ${document.Nomenclature.Header}` : $t("Не_указано")}}
                                                </div>
                                                <template v-else>
                                                    <div class="icon-click-row-group">
                                                        <div @click="onNomenclatureSelect">
                                                            <v-icon small v-tooltip.left-center="selectNomenclatureTooltip">
                                                                fas fa-edit
                                                            </v-icon>
                                                        </div>
                                                        <v-textarea
                                                            class="oneRowStartTextarea"
                                                            rows="1"
                                                            auto-grow
                                                            row-height="16"
                                                            no-resize
                                                            hide-details
                                                            required
                                                            outlined
                                                            dense
                                                            readonly
                                                            :value="document.Nomenclature ? `${document.Nomenclature.Code} ${document.Nomenclature.Header}` : ''"
                                                            :rules="requiredRule"
                                                        >
                                                        </v-textarea>
                                                    </div>
                                                </template>
                                            </v-col>
                                        </v-row>

                                        <!--Поле Номер регистрации, дата-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Номер_регистрации,_дата") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ concatedRegistrationData  }}
                                                </div>
                                                <div v-else class="more-inputs-in-row">

                                                    <v-text-field
                                                        :value="document.Card.RegNumber"
                                                        @input="update({ property: 'Data.Object.Document.Card.RegNumber', value: $event })"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        :rules="requiredRule"
                                                    >
                                                    </v-text-field>
                                                    <span>{{ $t("от_время_редактирование") }}</span>
                                                    <v-menu 
                                                        v-model="regDateMenu"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="290"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                :value="documentRegDate | formattedDate"
                                                                prepend-icon="mdi-calendar"
                                                                readonly
                                                                v-bind="attrs"
                                                                v-on="on" 
                                                                hide-details
                                                                required
                                                                outlined
                                                                dense
                                                                :rules="requiredRule"
                                                                class="datepick-input"
                                                            >
                                                            </v-text-field>
                                                        </template>

                                                        <v-date-picker
                                                            v-model="documentRegDate"
                                                            @input="regDateMenu = false"
                                                            color="teal"
                                                            :first-day-of-week="1"
                                                            :max="serverDate"
                                                        >
                                                        </v-date-picker>
                                                    </v-menu>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        
                                        <!--Поле Фактическая дата отправки-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Фактическая_дата_отправки") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ formatDate(document.Card.ActualOutgoingDate) }}
                                                </div>
                                                <v-menu
                                                    v-else
                                                    v-model="actualOutgoingDateMenu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            :value="actualOutgoingDate | formattedDate"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on" 
                                                            hide-details
                                                            required
                                                            outlined
                                                            dense
                                                            :rules="requiredRule"
                                                            class="datepick-input"
                                                        >
                                                        </v-text-field>
                                                    </template>

                                                    <v-date-picker
                                                        v-model="actualOutgoingDate"
                                                        @input="actualOutgoingDateMenu = false"
                                                        color="teal"
                                                        :first-day-of-week="1"
                                                        :min="documentRegDate"
                                                        :max="serverDate"
                                                    >
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                        
                                    </v-card-text>
                                </v-card>

                                <!--Обертка для блока Реквизиты документа-->
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Реквизиты_документа") }}</div>

                                        <!--поле Инициативный-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Инициативный") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.IsInitiative ? $t("Да") : $t("Нет") }}
                                                </div>
                                                <v-switch
                                                    v-else
                                                    :input-value="document.Card.IsInitiative"
                                                    @change="update({ property: 'Data.Object.Document.Card.IsInitiative', value: $event})"
                                                    inset
                                                    hide-details
                                                    class="cust-switch"
                                                />
                                            </v-col>
                                        </v-row>

                                        <!--поле Тип_документа-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Тип_документа") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.DocumentType ? document.Card.DocumentType.Value : $t("не_указано") }}
                                                </div>
                                                <v-autocomplete
                                                    v-else
                                                    :value="document.Card.DocumentType"
                                                    @input="update({ property: 'Data.Object.Document.Card.DocumentType', value: $event })"
                                                    :items="documentTypeItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>

                                        <!--поле Характер вопроса-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Характер_вопроса") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.QuestCharacter ? document.Card.QuestCharacter.Value : $t("не_указано") }}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="document.Card.QuestCharacter"
                                                    @input="update({ property: 'Data.Object.Document.Card.QuestCharacter', value: $event })"
                                                    :items="questCharacterItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    outlined
                                                    dense
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="questCharacterSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Язык документа-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Язык_документа") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">

                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.Languages ? documentLanguages.map((x) => x.Value).join(', ') : $t("Не_указано") }}
                                                </div>

                                                <v-autocomplete
                                                    v-else
                                                    v-model="documentLanguages"
                                                    :items="languageItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    multiple
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="multipleRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>

                                            </v-col>
                                        </v-row>

                                        <!--поле Тип носителя-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Тип_носителя") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    {{ document.Card.CarrierType ? document.Card.CarrierType.Value : $t("Не_указано") }}
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--поле Количество ЛП-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Количество_листов/приложений") }}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">

                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ `${document.Card.ListCount}/${document.Card.AttachCount}` }}
                                                </div>
                                                <div class="more-inputs-in-row" v-else>
                                                    <v-text-field
                                                        :value="document.Card.ListCount"
                                                        @input="update({ property: 'Data.Object.Document.Card.ListCount', value: $event })"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        type="number"
                                                        :rules="integerNotNull"
                                                        class="cust-inputnumber"
                                                        min="0"
                                                    >
                                                    </v-text-field>
                                                    <span>/</span>
                                                    <v-text-field
                                                        :value="document.Card.AttachCount"
                                                        @input="update({ property: 'Data.Object.Document.Card.AttachCount', value: $event })"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        type="number"
                                                        :rules="integerRule.concat(requiredRule)"
                                                        class="cust-inputnumber"
                                                        min="0"
                                                    >
                                                    </v-text-field>
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>
                                
                            </v-col>
                            
                            <!--Обертка для секции-->
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">

                                <!--Обертка для блока Исполнитель/Автор_документа-->
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Исполнитель/Автор_документа") }}</div>

                                        <!--поле Исполнитель-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Исполнитель") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="icon-click-row-group icrg-align-center">                                                    
                                                    <div v-if="!isViewMode" @click="onExecuterSelect">
                                                        <v-icon small v-tooltip.left-center="selectExecuterTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div class="onlyReadData">
                                                        <v-workplace-chip v-if="document.Card.ExecuterName"
                                                            :id="document.Card.ExecuterWorkplaceId"
                                                            :name="document.Card.ExecuterName"
                                                            :canDelete="!isViewMode"
                                                            :delFunc="onDeleteExecuter"
                                                        />
                                                        <div v-else class="chipAreaNoData d-flex align-center pl-1">
                                                            <v-select-members-chip
                                                                v-if="!isViewMode"
                                                                target-type="Member"
                                                                @on-select="onExecuterSelectByChip"
                                                                :items-params="executerSelectParam"
                                                                :required="true"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--поле Телефон исполнителя-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Телефон_исполнителя") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.Phone ? document.Card.Phone : $t("не_указано") }}
                                                </div>
                                                <v-text-field
                                                    v-else
                                                    :value="document.Card.Phone"
                                                    @input="update({ property: 'Data.Object.Document.Card.Phone', value: $event})"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                                <!--Обертка для блока Кем_создано-->
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Кем_создано") }}</div>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Сотрудник") }}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    <v-employee-chip :id="document.AuthorId" :name="document.AuthorName" />
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Дата_создания") }}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ formatDate(document.CreateDate) }}</div>
                                            </v-col>
                                        </v-row>
                                    
                                    </v-card-text>
                                </v-card>

                            </v-col>

                            <!--Обертка для секции-->
                            <v-col cols="12" sm="12" md="12" class="section-wrapper">
                                
                                <!--Блок Краткое содержание-->
                                <v-card flat>
                                    <v-card-text>

                                        <div class="form-box-title">{{ $t("Краткое_содержание") }}</div>

                                        <!--Поле Краткое содержание-->
                                        <v-row class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{ $t("Краткое_содержание") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="10">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Theme }}
                                                </div>
                                                <v-textarea v-else
                                                    :value="document.Theme"
                                                    @input="update({ property: 'Data.Object.Document.Theme', value: $event })"
                                                    rows="3"
                                                    no-resize
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-textarea>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>
                                
                                <!--Блок Кому_адресовано-->
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Кому_адресовано") }}</div>

                                        <v-row class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{ $t("Получатели") }}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="10">
                                                <div class="icon-click-row-group">
                                                    <div v-if="!isViewMode" @click="onRecipientsSelect">
                                                        <v-icon small v-tooltip.left-center="selectRecipientsTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div class="chipAreaNoData d-flex align-center pl-1" 
                                                        v-if="document.Card.Recipients.length == 0">
                                                        <v-select-members-chip
                                                            v-if="!isViewMode"
                                                            target-type="Member"
                                                            @on-select="onRecipientsSelectByChip"
                                                            :items-params="recipientsSelectParam"
                                                            :required="true"
                                                        />
                                                    </div>
                                                    <div class="onlyReadData more-per-lab-wrap" v-else>
                                                        <template v-for="recipient in document.Card.Recipients">
                                                            <v-enterprise-chip
                                                                v-if="recipient.ContractorType === 0"
                                                                :id="recipient.Id"
                                                                :key="recipient.Id"
                                                                :name="recipient.Name"
                                                                :is-esedo="recipient.IsEsedo"
                                                                :canDelete="!isViewMode"
                                                                :delFunc="onDeleteRecipient"
                                                            />
                                                            <v-workplace-chip
                                                                v-else
                                                                :disable-info="true"
                                                                :key="recipient.Id"
                                                                :id="recipient.Id"
                                                                :name="recipient.Name"
                                                                :is-esedo="recipient.IsEsedo"
                                                                :canDelete="!isViewMode"
                                                                :delFunc="onDeleteRecipient"
                                                            />
                                                        </template>
                                                        <v-select-members-chip
                                                            v-if="!isViewMode"
                                                            target-type="Member"
                                                            @on-select="onRecipientsSelectByChip"
                                                            :items-params="recipientsSelectParam"
                                                        />
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                            </v-col>

                        </v-row>
                    </v-form>
                </template>

                <template v-else-if="!!item">
                    <component
                        :is="$mapComponent(item.FormId)" 
                        :ref="item.FormId" 
                        :id="document.id"
                    />
                </template>
                
            </v-tab-item>

        </v-tabs-items>

    </div>
</template>

<script>
import i18n from '@/i18n';
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import sys from '@/services/system';

import Toolbar from '@/components/Toolbar.vue';
import DocumentPanel from '@/components/DocumentPanel.vue';

export default {
    name: "OutgoingDSPCard",
    components: {
        Toolbar,
        DocumentPanel
    },
    asyncComputed: {
        documentTypeItems: {
            async get() {
                return Array.from(await this.$store.dispatch('references/getReference', { id: 1001 }));
            },
            default: []
        },
        questCharacterItems: {
            async get () {
                let items = Array.from(await this.$store.dispatch('references/getReference', { id: 1003 }));

                if (this.questCharacterSearch)
                    return items.filter(i => sys.checkSearch(i.Value, this.questCharacterSearch) || i.id == this.document?.Card?.QuestCharacter?.id);
                else
                    return items;
            },
            default: [],
            watch: ['questCharacterSearch']
        },
        languageItems: {
            async get() {
                return Array.from(await this.$store.dispatch('references/getReference', { id: 1000 }));
            },
            default: []
        },
        serverDate: {
            async get() {
                return this.$moment(await this.$store.dispatch('references/getTimestamp')).format('YYYY-MM-DD');
            },
            default: null
        }
    },
    computed: {
        ...mapGetters('actionsource',
        {
            dataSource: 'getDataSource',
            dataSourceType: 'getDataSourceType'
        }),
        ...mapGetters({ 
            requiredRule: 'getRequiredRule',
            multipleRule: 'getMultipleRule',
            integerRule: 'getIntegerRule',
            integerNotNull: 'getIntegerNotNullRule'
        }),
        isViewMode() {
            return this.dataSource.Data.FormId == "0201111";
        },
        document() {
            return this.dataSource?.Data?.Object?.Document;
        },
        isRegistered() {
            return this.document?.RegState == 1 || this.document?.RegState == 4;
        },
        pages() {
            let pages = 
            [
                { Count: -1, FormId: this.document?.id, Name: i18n.t("Карточка") }
            ];

            pages = pages.concat(this.dataSource?.Data?.Object?.Pages ?? []);
            return pages;
        },
        documentLanguages: {
            get: function() {
                return this.document.Card.Languages?.data_list ?? [];
            },
            set: function(newValue) {
                if (this.document.Card.Languages != null)
                    this.updateSource({ property: 'Data.Object.Document.Card.Languages.data_list', value: newValue });
                else
                    this.updateSource({ property: 'Data.Object.Document.Card.Languages', value: { data_list: newValue } });
            }
        },
        concatedRegistrationData() {
            let result = i18n.t("Не_указано");

            if (this.document?.Card?.RegNumber?.length)
                result = `№ ${this.document.Card.RegNumber}`;

            if (this.document?.Card?.RegDate)
                result += ` ${this.$t("от_время")} ${this.formatDate(this.document.Card.RegDate)} г.`;

            return result;
        },
        //#region Tooltips
        selectExecuterTooltip() {
            return i18n.t("Выбрать_исполнителя");
        },
        selectRecipientsTooltip() {
            return i18n.t("Выбрать_получателей");
        },
        selectNomenclatureTooltip() {
            return i18n.t("Выбрать_номенклатуру");
        },
        //#endregion
        //#region Dates
        actualOutgoingDate: {
            get: function () {
                if (this.document?.Card?.ActualOutgoingDate)
                    return this.$moment(this.document.Card.ActualOutgoingDate).format('YYYY-MM-DD');
                
                return this.document?.Card?.ActualOutgoingDate;
            },
            set: function(newValue) {
                this.updateSource({ property: 'Data.Object.Document.Card.ActualOutgoingDate', value: `/Date(${Date.parse(newValue)})/` });
            }
        },
        documentRegDate: {
            get: function () {
                if (this.document?.Card?.RegDate)
                    return this.$moment(this.document.Card.RegDate).format('YYYY-MM-DD');
                
                return this.document?.Card?.RegDate;
            },
            set: function(newValue) {

                if (this.$moment(this.actualOutgoingDate).isBefore(this.$moment(newValue)) )
                    this.updateSource({ property: 'Data.Object.Document.Card.ActualOutgoingDate', value: null });

                this.updateSource({ property: 'Data.Object.Document.Card.RegDate', value: `/Date(${Date.parse(newValue)})/` });
            }
        },
        //#endregion
        executerSelectParam() {
            return { 
                title: i18n.t("Выбор_исполнителя"),
                includeInner: true,
                multiple: false,
                selected: [ this.document.Card.ExecuterWorkplaceId ]
            }
        },
        recipientsSelectParam() {
            return { 
                title: i18n.t("Выбор_получателей"),
                multiple: true,
                includeOuterEnterprises: true,
                includeJuridical: true,
                includePersons: true,
                selected: [ ...this.document.Card.Recipients.map(x => x.Id) ]
            }
        }
    },
    filters: {
        formattedDate: function (value) {
            var formatedDate = sys.dateFormat(value, 'DD.MM.YYYY');
            return formatedDate ?? "";
        }
    },
    data () {
        return {
            tab: null,
            /** Переменная для поиска по справочнику Характер вопроса */
            questCharacterSearch: "",
            /** Переменная для выбора даты исходящего в режиме редактирования */
            actualOutgoingDateMenu: false,
            /** Переменная для выбора даты исходящего в режиме редактирования */
            regDateMenu: false,
        }
    },
    methods: {
        ...mapActions('actionsource', { updateSource: 'updateDataSource' }),
        update: _.debounce(function (object) {
            this.updateSource(object);
        }, 250),
        formatDate(source) {
            return this.$moment(source).format('DD.MM.YYYY');
        },
        //обработка клика по вкладкам документа
        onTabClicked (formId) {
            if (formId === this.document?.id) return;

            let component = this.$refs[formId]?.[0];

            if (component)
                if (typeof component.update === 'function')
                    component.update();
        },
        async onToolbarClick(event, button) {
            let actions = Reflect.ownKeys(this.$store._actions).filter(i => i.includes('actionsource/')).map(i => {return i.split('/')[1]})
            
            if (actions.includes(button.Action)) {
                
                if (button.Action == 'Save' || button.Action == 'SaveAndClose') {

                    let validate_result = this.$refs.form[0].validate();

                    if (validate_result && this.document.Card.Recipients.length > 0) {
                        await this.$store.dispatch(`actionsource/${button.Action}`, {event, button});        
                    }
                    else {
                        this.$notify.alert(i18n.t("Не_заполнены_обязательные_поля"));
                    }
                }
                else {
                    await this.$store.dispatch(`actionsource/${button.Action}`, {event, button});
                }
            }
            else
                this.$notify.alert(`Действие_${button.Action}_не_реализовано.`);
        },
        async onExecuterSelect() {
            try {
                let selectMemberParams = this.executerSelectParam;
                let executer = await this.$store.dispatch('dialogs/selectMembersNew/open', selectMemberParams);    
                this.setExecuter(executer);
            }
            catch (ex) {
                console.log(ex);
            }
        },
        async onExecuterSelectByChip(e){
            this.setExecuter(e.value);
        },
        async onDeleteExecuter(){
            this.setExecuter(null);
        },
        async setExecuter(value){
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName',  value: value?.name });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId',  value: value?.workplaceId });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId',  value: value?.employeeId });

            let phone = value?.contacts?.find(contact => { return contact.type === "phone"; }) ?? null;
            this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: phone?.value ?? null });
        },
        async onRecipientsSelect() {
            try {
                let selectMemberParams =  this.recipientsSelectParam;
                let recipients = await this.$store.dispatch('dialogs/selectMembersNew/open', selectMemberParams);
                this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: recipients.map(x => ({ ContractorType: x.type, Id: x.enterprise, IsEmployee: false, Name: x.name, IsEsedo: x.esedoMember }))});
            }
            catch (ex) {
                console.log(ex);
            }
        },
        async onRecipientsSelectByChip(e){
            let value = [ ...this.document.Card.Recipients, { ContractorType: e.value.type, Id: e.value.enterprise, IsEmployee: false, Name: e.value.name, IsEsedo: e.value.esedoMember }];
            this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value });
        },
        async onDeleteRecipient(id){
            let tmp = Array.from(this.document.Card.Recipients);
            let itemToRemove = tmp.find(x=>x.Id == id);
            if (itemToRemove) {
                let index = tmp.indexOf(itemToRemove);
                if (index > -1) {
                    tmp.splice(index, 1);
                    this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: tmp });
                }
            }
        },
        async onNomenclatureSelect() {
            try {
                let selected = await this.$store.dispatch('dialogs/selectNomenclature/open', null);
                this.updateSource({ property: 'Data.Object.Document.Nomenclature', value: { Code: selected[1], Header: selected[2] } });
                this.updateSource({ property: 'Data.Object.Document.NomenclatureId', value: selected[0] });
            }
            catch (ex) {
                console.log(ex.message);
            }
        },
    },
    async created() {
        (async() => {
            while(typeof this.$refs.form === 'undefined')
                await new Promise(resolve => setTimeout(resolve, 100));

            this.$refs?.form?.[0]?.validate();
        })();
    },
    updated() {
        if (this.dataSource !== null) {
            this.$refs?.form?.[0]?.validate();
        }  
    }
}
</script>